<template>
  <div
    class="grid marginB5Px"
    v-if="atributos.length > 0">
    <div
      class="col-12 md:col-6"
      v-for="(atributo, index) in atributos" :key="index"
      >
      <div>
        <p class="blueText marginB5Px">
          <em 
            v-if="atributo.tipoAtributoResponse.descripcion != null"
            class="pi pi-info-circle pr-1" 
            v-tooltip="atributo.tipoAtributoResponse.descripcion" />
          {{ atributo.nombre }}
          {{ atributo.nullable == true ? '*' : '' }}
        </p> 
        <div>
          <InputText
            v-if="atributo.tipoAtributoResponse.codigo === 'TEXTO_UNA_LINEA'"
            v-model="atributo.valor"
            :class="{ 'input invalid border-round-sm': atributo.errors.length > 0 }"
            :maxlength="atributo.maximo"
            :minlenght="atributo.minimo"
            @input="validate(atributo)"
          />
          <Textarea
            v-if="atributo.tipoAtributoResponse.codigo === 'TEXTO_MULTILINEA'"
            v-model="atributo.valor"
            :autoResize="true"
            :class="{ 'input invalid border-round-sm': atributo.errors.length > 0 }"
            :max="atributo.maximo"
            @keyup="validate(atributo)"
            @blur="validate(atributo)"
          />
          <InputSwitch 
            v-if="atributo.tipoAtributoResponse.codigo === 'CHECK'" 
            v-model="atributo.valor"    
          />
          
          <InputNumber
            v-if="atributo.tipoAtributoResponse.codigo === 'NUMERO'"
            v-model="atributo.valor"
            showButtons
            :max="atributo.maximo"
            :min="atributo.minimo"
            :class="{ 'input invalid border-round-sm': atributo.errors.length > 0 }"
            @keydown="isDecimal($event, false),validate(atributo)"
            @blur="validate(atributo)"
          />
          <InputNumber
            v-if="atributo.tipoAtributoResponse.codigo === 'DECIMAL'"
            v-model="atributo.valor"
            mode="decimal"
            :maxFractionDigits="atributo.numeroDecimales"  
            :class="{ 'input invalid border-round-sm': atributo.errors.length > 0 }"
            :max="atributo.maximoDouble"
            :min="atributo.minimoDouble"
            showButtons
            @keyup="validate(atributo)"
            @blur="validate(atributo)"
          />
          <Calendar
            v-if="atributo.tipoAtributoResponse.codigo === 'FECHA'"
            v-model="atributo.valor"
            :dateFormat="selectedFormatoFecha(atributo)"
            :class="{ 'input invalid border-round-sm': atributo.errors.length > 0 }"
            :maxDate="atributo.maximo"
            :minDate="atributo.minimo"
            :showIcon="true"
            :showTime="false"
            @blur="validate(atributo)"
            />
          <Dropdown
            v-if="atributo.tipoAtributoResponse.codigo === 'LISTA_UNICA'"
            v-model="atributo.selected"
            v-on:change="validate(atributo)"
            class="input"
            optionLabel="name"
            :class="{ 'invalid border-round-sm': atributo.errors.length > 0 }"
            @change="atributo.valor=atributo.selected.name; atributo.errors = []"
            :options="atributo.lista"
            :placeholder="atributo.listadoValoresResponse ? atributo.listadoValoresResponse.nombre : ''"
          /> 
          <MultiSelect
            v-if="atributo.tipoAtributoResponse.codigo === 'LIST_MULTIPLE'"
            v-model="atributo.selected"
            @change="validate(atributo)"
            @blur="validate(atributo)"
            class="input"
            optionLabel="name"
            scrollHeight="200px"
            :class="{ 'invalid border-round-sm': atributo.errors.length > 0 }"
            :options="atributo.lista"
            :placeholder="atributo.listadoValoresResponse ? atributo.listadoValoresResponse.nombre : ''"
          />
          <div class="grid errors">
            <small 
              v-for="error in atributo.errors" 
              v-bind:key=error 
              class="invalid col-12" >
              {{ error }}
            </small>
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>  
  import moment from 'moment';
  import { GET_SEGMENTO } from "@/graphQLQueries/SegmentosQueries";
  import { GET_LISTA_CARTERAS } from "@/graphQLQueries/CarterasQueries";

  export default {
    name: "Segmento",
    props: [
      "carteraUsuario",
      "nivel",
      "contrato",
      "tipoEntidad"
    ],
    data() {
      return {
        valueCheck: null,
        checkDropdown: [],
        atributos: [],
        atributosCopia: [],
        valor: null,
        formatoFechaCalendar: null,
        formatoFechaActual: null
      };
    },
    created(){
      this.obtenerCartera()
      this.getSegmento()
    },
    watch: {
      carteraUsuario() {
        this.atributos = []
        this.obtenerCartera()
        this.getSegmento()
      },
    },
    methods: {
      getSegmento(){
        if (this.carteraUsuario != null && this.carteraUsuario.segmento){
          this.$apollo.query({
            query: GET_SEGMENTO,
            variables: {
              idSegmento: this.carteraUsuario.segmento.id
            },
            fetchPolicy: "no-cache",
          })
          .then((data) => {
            this.atributos = []
            let atributosSegmento = data.data.segmento.atributos
            if (this.carteraUsuario != null){
              if (!this.nivel){
                this.atributos = atributosSegmento
              }else{
                for (let atributo of atributosSegmento) {
                  if (atributo.nivel === this.nivel){
                    atributo.valor = this.valorPorDefecto(atributo)
                    atributo.lista = this.cargarListaDropdown(atributo)
                    atributo.selected = null
                    if(atributo.tipoAtributoResponse.codigo === 'LISTA_UNICA' && atributo.valor != "") {
                      let opcionLista = atributo.lista.filter(lista => lista.code.toUpperCase() == atributo.valor.toUpperCase())
                      atributo.selected = opcionLista[0]
                      atributo.valor = opcionLista[0].name
                    }
                    atributo.errors = []
                    if(this.atributosCopia.length > 0) {
                      this.atributosCopia.forEach(a => {
                        if(atributo.id == a.id && atributo.errors.length == 0 && (a.valor == null || a.valor == ""))
                          atributo.errors = a.errors;
                        if(atributo.id == a.id && atributo.valor != null)
                          atributo.valor = a.valor
                      });
                    }
                    this.atributos.push(atributo)
                  } 
                }
                this.atributosCopia = JSON.parse(JSON.stringify(this.atributos))
              }
            }
            this.calculaLimiteFecha()
          })
          .catch((exception) => {
            this.errors = [];
            exception.graphQLErrors.forEach((error) => {
              this.errors.push(error.message);
            });
          });
        }else{
          this.atributos = []
        }
      },
      obtenerCartera() {
        if(this.carteraUsuario) {
          this.$apollo
            .query({
              query: GET_LISTA_CARTERAS,
              variables: {
                filter: [
                  `id~eq=${this.carteraUsuario.id}`,
                ],
                page: 0,
                size: 1,
              },
              fetchPolicy: "no-cache",
            })
            .then((data) => {
              if(data.data.listadoCarteras.results[0].segmento)
                this.carteraUsuario.segmento.id = data.data.listadoCarteras.results[0].segmento.id
            }).catch(() => {
            });
        }
      },
      valorPorDefecto(atributo){
        let valor = ''
        if (atributo.bigintPorDefecto != null)
          valor = atributo.bigintPorDefecto
        if (atributo.doublePorDefecto != null)
          valor = atributo.doublePorDefecto
        if (atributo.textPorDefecto != null)
          valor = atributo.textPorDefecto
        if (atributo.tipoAtributoResponse.codigo === 'CHECK'){
          switch (atributo.bigintPorDefecto) {
            case 0:
              valor = false;
              break;
            case 1:
              valor = true;
              break;
            default:
              valor = null;
              break;
          }
        } 
        if (atributo.tipoAtributoResponse.codigo === 'FECHA'){
          if (atributo.bigintPorDefecto != null){
            valor = new Date(atributo.bigintPorDefecto)
          }
        } 
        if ((atributo.tipoAtributoResponse.codigo === 'NUMERO' || atributo.tipoAtributoResponse.codigo === 'DECIMAL') && valor == ''){
          valor = 0
        }
        return valor
      },
      dateFormat(atributo){
          let ejemploFormat = atributo.textPorDefecto
          if (ejemploFormat != null){
            if (this.codigoAtributo === 'NUMERO')
              ejemploFormat=new Intl.NumberFormat('es-ES').format(ejemploFormat)
            if(this.codigoAtributo === 'FECHA')
              ejemploFormat = moment(this.valor).format(this.formatoFechaActual)
            if (this.codigoAtributo === 'DECIMAL')
              ejemploFormat=new Intl.NumberFormat('es-ES', 
              {  
                style: 'decimal',
                maximumFractionDigits: atributo.numeroDecimales,
                minimumFractionDigits: atributo.numeroDecimales 
              }
              ).format(ejemploFormat)
          }          
          atributo.textPorDefecto = ejemploFormat
         },
      validate(atributo) {
        atributo.errors=[]
        if(atributo.valor != null){
          if (atributo.tipoAtributoResponse.codigo === 'LIST_MULTIPLE' || atributo.tipoAtributoResponse.codigo === 'LISTA_UNICA'){
            this.validateLista(atributo);  
          }
          if (atributo.tipoAtributoResponse.codigo === 'FECHA'){
            this.validateFecha(atributo);    
          }
          if (atributo.tipoAtributoResponse.codigo === 'NUMERO'){
            this.validateNumero(atributo);
          }
          if (atributo.tipoAtributoResponse.codigo === 'DECIMAL'){
            this.validateDecimal(atributo);
          }
          if (atributo.tipoAtributoResponse.codigo === 'TEXTO_UNA_LINEA'){
            this.validaTipoText(atributo) 
          }
          if (atributo.tipoAtributoResponse.codigo === 'TEXTO_UNA_LINEA' ||
              atributo.tipoAtributoResponse.codigo === 'TEXTO_MULTILINEA'){
                this.validateTexto(atributo)
          }
        } else {
          if(atributo.nullable) {
            atributo.errors.push(
              this.$i18n.t("detalleAtributo.errores.noVacio")
            );
          }
        }
      },
      validateLista(atributo){
        if(atributo.lista.length === 0 && atributo.nullable){
          atributo.errors.push(
            this.$i18n.t("detalleAtributo.errores.listadoVacio")
          );
        }
        if(atributo.tipoAtributoResponse.codigo === 'LIST_MULTIPLE' && atributo.selected.length > 0) {
          atributo.valor = atributo.selected.map(opcion => { return opcion.name }); 
          atributo.valor = atributo.valor.toString()
          atributo.errors = []
        }
      },
      validateFecha(atributo){
        if(atributo.valor || atributo.valor != null || atributo.valor != "")
          atributo.errors=[]
        if(atributo.maximo != null && atributo.valor) {
          let fechaMax = atributo.maximo
          fechaMax = new Date(fechaMax)
          if (atributo.valor.getTime()>fechaMax.getTime()){
            atributo.errors.push(
                this.$i18n.t("detalleAtributo.errores.maximaFecha") + 
                moment(fechaMax).format("DD/MM/YYYY"))   
          }
        }
        if(atributo.minimo != null && atributo.valor) {
          let fechaMin = atributo.minimo
          fechaMin = new Date(fechaMin)
          if (atributo.valor.getTime()<fechaMin.getTime()){
            this.formError = true
            atributo.errors.push(
                this.$i18n.t("detalleAtributo.errores.minimaFecha") + 
                moment(fechaMin).format("DD/MM/YYYY"))   
          }
        }
      },
      validateNumero(atributo){
        if(atributo.maximo != null && atributo.valor>atributo.maximo){
          this.formError = true
          atributo.errors.push(
            this.$i18n.t("detalleAtributo.errores.maximoValor") + atributo.maximo
          )
        }
        if(atributo.minimo != null && atributo.valor<atributo.minimo){
          this.formError = true
          atributo.errors.push(
            this.$i18n.t("detalleAtributo.errores.minimoValor") + atributo.minimo
          )
        }
      },
      validateDecimal(atributo){
        if (atributo.maximoDouble != null && atributo.valor > atributo.maximoDouble){
          this.formError = true
          atributo.errors.push(
              this.$i18n.t("detalleAtributo.errores.maximoValor") + atributo.maximoDouble
            )
        }
        if (atributo.minimoDouble != null && atributo.valor < atributo.minimoDouble){
          this.formError = true
          atributo.errors.push(
              this.$i18n.t("detalleAtributo.errores.minimoValor") + atributo.minimoDouble
            )
        }
      },
      validateTexto(atributo){
        let numCaracteres = atributo.valor.length > 0 ? atributo.valor.length : 0
        if (numCaracteres === 0 && (atributo.nullable)){
          atributo.errors.push(
            this.$i18n.t("detalleAtributo.errores.noVacio")
          );
        }
        if (atributo.minimo != null && numCaracteres<atributo.minimo){
          atributo.errors.push(
              this.$i18n.t("detalleAtributo.errores.minimoCaracteres") + atributo.minimo + " caracteres."
          );
        }
        if (atributo.maximo != null && numCaracteres>atributo.maximo){ 
          atributo.errors.push(
            this.$i18n.t("detalleAtributo.errores.maximoCaracteres") + atributo.maximo + " caracteres."
          );    
        }   
      },
      isDecimal(e, needComma) {
        let keyCode = e.which;
        if (keyCode === 46)
          return true;
        if ((keyCode !== 8 || keyCode === 32) && 
            (keyCode < 48 || keyCode > 57) && 
            (keyCode !== 188 || !needComma)) {
          e.preventDefault();
        }
      },
      selectedFormatoFecha(atributo){
        let formato = atributo.formatoFecha
        if(formato != null) {
          if (formato === 'DD/MM/AAAA')
            formato = 'dd/mm/yy'
          if (formato === 'D-M-AA')
            formato = 'd-m-y'
          if (formato === 'AAAA-MM-DD')
            formato = 'yy-mm-dd'
        } else
          formato = 'dd/mm/yy'
        return formato
      },
      cargarListaDropdown(atributo) {
        let nuevaLista = []
        let listadoValores = atributo.listadoValoresResponse
        let listaAuxiliar
        
        if (listadoValores != null){
          listaAuxiliar = listadoValores.lista
          listaAuxiliar = listaAuxiliar.split(";")
          listaAuxiliar.forEach(elementoLista => {
            if(elementoLista != '') {
              let nuevaListaAux = elementoLista.split("->")
              let obj = {
                code: nuevaListaAux[0],
                name: nuevaListaAux[1].replaceAll(";",""),
              }
              nuevaLista.push(obj);
            }
          });
        return nuevaLista
        }
      },
      validaTipoText(atributo) {
      if(atributo.validadorEspecificoResponse != null) {
        if(atributo.validadorEspecificoResponse.id == 1) { //URL
          this.validaUrl(atributo);
        } else if(atributo.validadorEspecificoResponse.id == 2) { //EMAIL
          this.validaEmail(atributo);
        } else if(atributo.validadorEspecificoResponse.id == 3) { //CUP
          this.validaCup(atributo);
        }
      }
    },
    validaUrl(atributo) {
      let res = atributo.valor.match(/((http?|https):\/\/)?([Ww]{3}.)?[a-zA-Z0-9]+\.[a-zA-Z]+/g);
      if(!res || res == null) {
        this.formError = true
        atributo.errors.push(this.$i18n.t('detalleAtributo.errores.urlInvalida'));
      } 
    },
    validaEmail(atributo) {
      let res = atributo.valor.match(/[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)/g);
      if(!res || res == null) {
        this.formError = true
        atributo.errors.push(this.$i18n.t('detalleAtributo.errores.emailInvalido'));
      }
    },
    validaCup(atributo) {
      let cup = atributo.valor.replaceAll(" ","")
      let ret = false;
      const reCUPS = /^[A-Z]{2}(\d{4}\d{12})([TRWAGMYFPDXBNJZSQVHLCKE]{2})(\d[FPCRXYZ])?$/i;
      if (reCUPS.test(cup)) {
        const mCUPS = cup.toUpperCase().match(reCUPS);
        const [, cups16, control] = mCUPS;
        const letters = [
          'T', 'R', 'W', 'A', 'G', 'M',
          'Y', 'F', 'P', 'D', 'X', 'B',
          'N', 'J', 'Z', 'S', 'Q', 'V',
          'H', 'L', 'C', 'K', 'E',
        ];

        const cup16Mod = +cups16 % 529,
          quotient = Math.floor(cup16Mod / letters.length),
          remainder = cup16Mod % letters.length;

        ret = (control === letters[quotient] + letters[remainder]);
      }
      if(!ret) {
        this.formError = true
        atributo.errors.push(this.$i18n.t('detalleAtributo.errores.cupInvalido'));
      } 
    },
    getJsonSegmento(){
      let jsonSegmento = {}
      this.atributos.map(atributo =>  {
        if(atributo.tipoAtributoResponse.codigo === 'FECHA' && atributo.valor) {
          atributo.valor = moment(atributo.valor).format('DD/MM/YYYY')
        }
      })
      jsonSegmento = this.atributos.reduce(
        (json, atrb) => Object.assign(json, { [atrb.nombre]: atrb.valor }), {}
      );
      jsonSegmento = JSON.stringify(jsonSegmento)
      this.atributosCopia.forEach(ac => {
        this.atributos.forEach(a => {
          if(ac.id == a.id && ac.errors.length == 0 && (a.valor == null || a.valor == ""))
            ac.errors = a.errors;
          if(ac.id == a.id && ac.valor != null)
            ac.valor = a.valor
        });
      });
      this.getSegmento()
      return (jsonSegmento)
    },
    getErrors(){
      let errors = [];
      let atributos = this.atributos.filter(a => a.nullable && (a.valor == null || a.valor == "")).length
      this.atributos.filter(a => { if(a.nullable && (a.valor == null || a.valor == "")){ a.errors.push(this.$i18n.t("detalleAtributo.errores.noVacio"));}})
      if(atributos > 0)
        errors.push(this.$i18n.t("detalleAtributo.errores.atributoObligatorio"));
      return errors;
    },
    editImpago(impago) {
      let jsonAtributos = Object.entries(JSON.parse(impago.jsonSegmento))
      jsonAtributos.forEach(element => {
        this.atributos.forEach(a => {
          if(element[0] == a.nombre) {
            a.valor = element[1]
          }
        });
      });
    },
    limpiaValores() {
      this.atributos = []
      this.atributosCopia = []
      this.getSegmento()
    },
    getImporte(importe) {
      this.atributos.filter(a => a.tipoAtributoResponse.codigo === 'NUMERO').map(a => {a.maximo = importe })
      this.atributos.filter(a => a.tipoAtributoResponse.codigo === 'DECIMAL').map(a => {a.maximoDouble = importe })
    },
    calculaLimiteFecha() {
      if(this.contrato) {
        const now = new Date();

        const years = "deudorEntidad" == this.tipoEntidad ? this.contrato.periodoExpiracionPPJJ : this.contrato.periodoExpiracionPPFF;
        const limit = new Date(
          now.getFullYear() - years,
          now.getMonth(),
          now.getDate()
        );
        this.atributos.filter(a => a.tipoAtributoResponse.codigo === 'FECHA').map(a => {a.maximo = now; a.minimo = limit})
      }
    }
  }
}
  </script>
  <style lang="scss" scoped>
    input{
      min-width: 200px;
    }
    span.result{
      max-width: 300px;
      word-wrap: break-word;
    }
    .textAreaResult{
      color: black !important;
      border: none;
      opacity: 1;
    }
    .invalid {
      border-color: red !important;
      
    }
    small.invalid {
      color: red;
      height: 16px;
    }
    TextArea {
      width: 100%;
      min-height: 140px;
    }
    i {
      height: 100%;
      vertical-align: bottom;
    }
    .grid{ 
      margin-bottom: 3%;
    }
    .errors{
      margin-top: 1px;
      margin-bottom: 15px;
    }
  </style>